export const totemList = [
  {
    quality: 'blue',
    key: 'fertility',
    desc: 'Fertility',
    nodes: 2,
    maxLevel: 60,
    bonusA: { level: 24, statDesc: 'Infantry and Cavalry HP Boost', stat: 2 },
    bonusB: { level: 48, statDesc: 'Infantry and Cavalry HP Boost', stat: 2 },
    skillDesc: 'Fertility Blessing',
    skillEffect: [
      {
        desc: "When the battle starts, the Spirit of Fertility will send blessings. Increase HP of my Lord's Infantry and Cavalry by $%"
      },
      { desc: 'Fertility Blessing will also reduce the damage taken by Infantry and Cavalry by $%' }
    ],
    skillStats: [],
    skillLevels: []
  },
  {
    quality: 'blue',
    key: 'hunting',
    desc: 'Hunting',
    nodes: 2,
    maxLevel: 60,
    bonusA: { level: 24, statDesc: 'Increase the Attack of Archers and Mages', stat: 2 },
    bonusB: { level: 48, statDesc: 'Increase the Attack of Archers and Mages', stat: 2 },
    skillDesc: 'Hunting Blessing',
    skillEffect: [],
    skillStats: [],
    skillLevels: []
  },
  {
    quality: 'purple',
    key: 'fire',
    desc: 'Fire',
    nodes: 3,
    maxLevel: 150,
    bonusA: { level: 48, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.5 },
    bonusB: { level: 96, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.5 },
    skillDesc: 'Fire Hammer',
    skillEffect: [],
    skillStats: [],
    skillLevels: []
  },
  {
    quality: 'purple',
    key: 'darkness',
    desc: 'Darkness',
    nodes: 3,
    maxLevel: 150,
    bonusA: { level: 48, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.5 },
    bonusB: { level: 96, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.5 },
    skillDesc: '',
    skillEffect: [],
    skillStats: [],
    skillLevels: []
  },
  {
    quality: 'purple',
    key: 'order',
    desc: 'Order',
    nodes: 3,
    maxLevel: 150,
    bonusA: { level: 48, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.5 },
    bonusB: { level: 96, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.5 },
    skillDesc: '',
    skillEffect: [],
    skillStats: [],
    skillLevels: []
  },
  {
    quality: 'gold',
    key: 'earth',
    desc: 'Earth',
    nodes: 3,
    maxLevel: 150,
    bonusA: { level: 48, statDesc: 'Troops Damage Taken Reduction', stat: 0.5 },
    bonusB: { level: 96, statDesc: 'Troops Damage', stat: 0.5 },
    skillDesc: '',
    skillEffect: [],
    skillStats: [],
    skillLevels: []
  },
  {
    quality: 'gold',
    key: 'wrath',
    desc: 'Wrath',
    nodes: 3,
    maxLevel: 150,
    bonusA: { level: 48, statDesc: 'Troops Damage Taken Reduction', stat: 0.5 },
    bonusB: { level: 96, statDesc: 'Troops Damage', stat: 0.5 },
    skillDesc: '',
    skillEffect: [],
    skillStats: [],
    skillLevels: []
  },
  {
    quality: 'gold',
    key: 'guard',
    desc: 'Guard',
    nodes: 3,
    maxLevel: 150,
    bonusA: { level: 48, statDesc: 'Troops Damage Taken Reduction', stat: 0.5 },
    bonusB: { level: 96, statDesc: 'Troops Damage', stat: 0.5 },
    skillDesc: '',
    skillEffect: [],
    skillStats: [],
    skillLevels: []
  }
]

export const totemStats = {
  fertility: [
    { node: 1, level: 1, stones: 50, statDesc: 'Archer HP', stat: 0.6 },
    { node: 1, level: 2, stones: 50, statDesc: 'Archer HP', stat: 0.6 },
    { node: 1, level: 3, stones: 50, statDesc: 'Archer HP', stat: 0.6 },
    { node: 1, level: 4, stones: 130, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 1, level: 5, stones: 130, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 1, level: 6, stones: 130, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 1, level: 7, stones: 186, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 1, level: 8, stones: 186, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 1, level: 9, stones: 186, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 1, level: 10, stones: 195, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 1, level: 11, stones: 195, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 1, level: 12, stones: 195, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 1, level: 13, stones: 204, statDesc: 'Mage HP', stat: 0.6 },
    { node: 1, level: 14, stones: 204, statDesc: 'Mage HP', stat: 0.6 },
    { node: 1, level: 15, stones: 204, statDesc: 'Mage HP', stat: 0.6 },
    { node: 1, level: 16, stones: 213, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 1, level: 17, stones: 213, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 1, level: 18, stones: 213, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 1, level: 19, stones: 223, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 20, stones: 223, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 21, stones: 223, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 22, stones: 233, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 1, level: 23, stones: 233, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 1, level: 24, stones: 233, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 1, level: 25, stones: 244, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 1, level: 26, stones: 244, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 1, level: 27, stones: 244, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 1, level: 28, stones: 255, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 29, stones: 255, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 30, stones: 255, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 31, stones: 358, statDesc: 'Archer HP', stat: 0.6 },
    { node: 1, level: 32, stones: 358, statDesc: 'Archer HP', stat: 0.6 },
    { node: 1, level: 33, stones: 358, statDesc: 'Archer HP', stat: 0.6 },
    { node: 1, level: 34, stones: 387, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 1, level: 35, stones: 387, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 1, level: 36, stones: 387, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 1, level: 37, stones: 418, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 1, level: 38, stones: 418, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 1, level: 39, stones: 418, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 1, level: 40, stones: 451, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 1, level: 41, stones: 451, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 1, level: 42, stones: 451, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 1, level: 43, stones: 487, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 44, stones: 487, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 45, stones: 487, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 46, stones: 526, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 1, level: 47, stones: 526, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 1, level: 48, stones: 526, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 1, level: 49, stones: 568, statDesc: 'Mage HP', stat: 0.6 },
    { node: 1, level: 50, stones: 568, statDesc: 'Mage HP', stat: 0.6 },
    { node: 1, level: 51, stones: 568, statDesc: 'Mage HP', stat: 0.6 },
    { node: 1, level: 52, stones: 614, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 1, level: 53, stones: 614, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 1, level: 54, stones: 614, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 1, level: 55, stones: 663, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 1, level: 56, stones: 663, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 1, level: 57, stones: 663, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 1, level: 58, stones: 716, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 59, stones: 716, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 60, stones: 716, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 1, stones: 50, statDesc: 'Mage HP', stat: 0.6 },
    { node: 2, level: 2, stones: 50, statDesc: 'Mage HP', stat: 0.6 },
    { node: 2, level: 3, stones: 50, statDesc: 'Mage HP', stat: 0.6 },
    { node: 2, level: 4, stones: 130, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 2, level: 5, stones: 130, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 2, level: 6, stones: 130, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 2, level: 7, stones: 186, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 2, level: 8, stones: 186, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 2, level: 9, stones: 186, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 2, level: 10, stones: 195, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 2, level: 11, stones: 195, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 2, level: 12, stones: 195, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 2, level: 13, stones: 204, statDesc: 'Archer HP', stat: 0.6 },
    { node: 2, level: 14, stones: 204, statDesc: 'Archer HP', stat: 0.6 },
    { node: 2, level: 15, stones: 204, statDesc: 'Archer HP', stat: 0.6 },
    { node: 2, level: 16, stones: 213, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 2, level: 17, stones: 213, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 2, level: 18, stones: 213, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 2, level: 19, stones: 223, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 20, stones: 223, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 21, stones: 223, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 22, stones: 233, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 2, level: 23, stones: 233, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 2, level: 24, stones: 233, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 2, level: 25, stones: 244, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 2, level: 26, stones: 244, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 2, level: 27, stones: 244, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 2, level: 28, stones: 255, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 29, stones: 255, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 30, stones: 255, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 31, stones: 358, statDesc: 'Mage HP', stat: 0.6 },
    { node: 2, level: 32, stones: 358, statDesc: 'Mage HP', stat: 0.6 },
    { node: 2, level: 33, stones: 358, statDesc: 'Mage HP', stat: 0.6 },
    { node: 2, level: 34, stones: 387, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 2, level: 35, stones: 387, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 2, level: 36, stones: 387, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 2, level: 37, stones: 418, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 2, level: 38, stones: 418, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 2, level: 39, stones: 418, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 2, level: 40, stones: 451, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 2, level: 41, stones: 451, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 2, level: 42, stones: 451, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 2, level: 43, stones: 487, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 44, stones: 487, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 45, stones: 487, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 46, stones: 526, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 2, level: 47, stones: 526, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 2, level: 48, stones: 526, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 2, level: 49, stones: 568, statDesc: 'Archer HP', stat: 0.6 },
    { node: 2, level: 50, stones: 568, statDesc: 'Archer HP', stat: 0.6 },
    { node: 2, level: 51, stones: 568, statDesc: 'Archer HP', stat: 0.6 },
    { node: 2, level: 52, stones: 614, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 2, level: 53, stones: 614, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 2, level: 54, stones: 614, statDesc: 'Cavalry HP', stat: 0.9 },
    { node: 2, level: 55, stones: 663, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 2, level: 56, stones: 663, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 2, level: 57, stones: 663, statDesc: 'Infantry HP', stat: 0.9 },
    { node: 2, level: 58, stones: 716, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 59, stones: 716, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 60, stones: 716, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 }
  ],
  hunting: [
    { node: 1, level: 1, stones: 50, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 1, level: 2, stones: 50, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 1, level: 3, stones: 50, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 1, level: 4, stones: 130, statDesc: 'Archer HP', stat: 0.6 },
    { node: 1, level: 5, stones: 130, statDesc: 'Archer HP', stat: 0.6 },
    { node: 1, level: 6, stones: 130, statDesc: 'Archer HP', stat: 0.6 },
    { node: 1, level: 7, stones: 186, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 1, level: 8, stones: 186, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 1, level: 9, stones: 186, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 1, level: 10, stones: 195, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 1, level: 11, stones: 195, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 1, level: 12, stones: 195, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 1, level: 13, stones: 204, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 1, level: 14, stones: 204, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 1, level: 15, stones: 204, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 1, level: 16, stones: 213, statDesc: 'Mage HP', stat: 0.6 },
    { node: 1, level: 17, stones: 213, statDesc: 'Mage HP', stat: 0.6 },
    { node: 1, level: 18, stones: 213, statDesc: 'Mage HP', stat: 0.6 },
    { node: 1, level: 19, stones: 223, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 20, stones: 223, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 21, stones: 223, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 22, stones: 233, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 1, level: 23, stones: 233, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 1, level: 24, stones: 233, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 1, level: 25, stones: 244, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 1, level: 26, stones: 244, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 1, level: 27, stones: 244, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 1, level: 28, stones: 255, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 29, stones: 255, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 30, stones: 255, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 31, stones: 358, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 1, level: 32, stones: 358, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 1, level: 33, stones: 358, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 1, level: 34, stones: 387, statDesc: 'Archer HP', stat: 0.6 },
    { node: 1, level: 35, stones: 387, statDesc: 'Archer HP', stat: 0.6 },
    { node: 1, level: 36, stones: 387, statDesc: 'Archer HP', stat: 0.6 },
    { node: 1, level: 37, stones: 418, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 1, level: 38, stones: 418, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 1, level: 39, stones: 418, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 1, level: 40, stones: 451, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 1, level: 41, stones: 451, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 1, level: 42, stones: 451, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 1, level: 43, stones: 487, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 44, stones: 487, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 45, stones: 487, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 46, stones: 526, statDesc: 'Mage HP', stat: 0.6 },
    { node: 1, level: 47, stones: 526, statDesc: 'Mage HP', stat: 0.6 },
    { node: 1, level: 48, stones: 526, statDesc: 'Mage HP', stat: 0.6 },
    { node: 1, level: 49, stones: 568, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 1, level: 50, stones: 568, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 1, level: 51, stones: 568, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 1, level: 52, stones: 614, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 1, level: 53, stones: 614, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 1, level: 54, stones: 614, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 1, level: 55, stones: 663, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 1, level: 56, stones: 663, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 1, level: 57, stones: 663, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 1, level: 58, stones: 716, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 59, stones: 716, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 60, stones: 716, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 1, stones: 50, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 2, level: 2, stones: 50, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 2, level: 3, stones: 50, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 2, level: 4, stones: 130, statDesc: 'Mage HP', stat: 0.6 },
    { node: 2, level: 5, stones: 130, statDesc: 'Mage HP', stat: 0.6 },
    { node: 2, level: 6, stones: 130, statDesc: 'Mage HP', stat: 0.6 },
    { node: 2, level: 7, stones: 186, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 2, level: 8, stones: 186, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 2, level: 9, stones: 186, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 2, level: 10, stones: 195, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 2, level: 11, stones: 195, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 2, level: 12, stones: 195, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 2, level: 13, stones: 204, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 2, level: 14, stones: 204, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 2, level: 15, stones: 204, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 2, level: 16, stones: 213, statDesc: 'Archer HP', stat: 0.6 },
    { node: 2, level: 17, stones: 213, statDesc: 'Archer HP', stat: 0.6 },
    { node: 2, level: 18, stones: 213, statDesc: 'Archer HP', stat: 0.6 },
    { node: 2, level: 19, stones: 223, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 20, stones: 223, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 21, stones: 223, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 22, stones: 233, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 2, level: 23, stones: 233, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 2, level: 24, stones: 233, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 2, level: 25, stones: 244, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 2, level: 26, stones: 244, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 2, level: 27, stones: 244, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 2, level: 28, stones: 255, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 29, stones: 255, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 30, stones: 255, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 31, stones: 358, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 2, level: 32, stones: 358, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 2, level: 33, stones: 358, statDesc: 'Cavalry Attack', stat: 0.6 },
    { node: 2, level: 34, stones: 387, statDesc: 'Mage HP', stat: 0.6 },
    { node: 2, level: 35, stones: 387, statDesc: 'Mage HP', stat: 0.6 },
    { node: 2, level: 36, stones: 387, statDesc: 'Mage HP', stat: 0.6 },
    { node: 2, level: 37, stones: 418, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 2, level: 38, stones: 418, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 2, level: 39, stones: 418, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 2, level: 40, stones: 451, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 2, level: 41, stones: 451, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 2, level: 42, stones: 451, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 2, level: 43, stones: 487, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 44, stones: 487, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 45, stones: 487, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 46, stones: 526, statDesc: 'Archer HP', stat: 0.6 },
    { node: 2, level: 47, stones: 526, statDesc: 'Archer HP', stat: 0.6 },
    { node: 2, level: 48, stones: 526, statDesc: 'Archer HP', stat: 0.6 },
    { node: 2, level: 49, stones: 568, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 2, level: 50, stones: 568, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 2, level: 51, stones: 568, statDesc: 'Infantry Attack', stat: 0.6 },
    { node: 2, level: 52, stones: 614, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 2, level: 53, stones: 614, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 2, level: 54, stones: 614, statDesc: 'Mage Attack', stat: 0.9 },
    { node: 2, level: 55, stones: 663, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 2, level: 56, stones: 663, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 2, level: 57, stones: 663, statDesc: 'Archer Attack', stat: 0.9 },
    { node: 2, level: 58, stones: 716, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 59, stones: 716, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 60, stones: 716, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 }
  ],
  fire: [
    { node: 1, level: 1, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 2, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 3, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 4, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 5, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 6, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 7, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 8, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 9, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 10, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 11, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 12, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 13, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 14, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 15, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 16, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 17, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 18, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 19, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 20, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 21, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 22, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 23, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 24, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 25, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 26, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 27, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 28, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 29, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 30, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 31, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 32, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 33, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 34, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 35, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 36, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 37, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 38, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 39, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 40, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 41, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 42, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 43, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 44, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 45, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 46, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 47, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 48, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 49, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 50, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 51, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 52, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 53, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 54, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 55, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 56, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 57, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 58, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 59, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 60, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 61, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 62, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 63, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 64, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 65, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 66, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 67, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 68, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 69, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 70, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 71, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 72, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 73, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 74, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 75, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 76, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 77, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 78, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 79, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 80, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 81, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 82, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 83, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 84, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 85, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 86, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 87, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 88, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 89, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 90, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 91, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 92, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 93, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 94, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 95, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 96, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 97, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 98, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 99, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 100, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 101, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 102, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 103, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 104, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 105, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 106, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 107, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 108, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 109, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 110, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 111, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 112, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 113, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 114, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 115, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 116, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 117, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 118, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 119, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 120, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 121, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 122, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 123, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 124, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 125, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 126, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 127, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 128, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 129, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 130, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 131, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 132, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 133, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 134, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 135, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 136, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 137, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 138, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 139, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 140, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 141, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 142, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 143, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 144, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 145, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 146, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 147, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 148, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 149, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 150, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 1, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 2, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 3, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 4, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 5, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 6, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 7, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 8, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 9, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 10, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 11, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 12, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 13, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 14, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 15, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 16, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 17, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 18, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 19, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 20, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 21, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 22, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 23, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 24, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 25, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 26, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 27, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 28, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 29, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 30, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 31, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 32, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 33, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 34, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 35, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 36, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 37, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 38, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 39, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 40, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 41, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 42, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 43, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 44, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 45, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 46, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 47, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 48, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 49, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 50, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 51, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 52, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 53, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 54, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 55, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 56, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 57, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 58, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 59, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 60, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 61, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 62, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 63, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 64, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 65, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 66, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 67, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 68, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 69, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 70, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 71, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 72, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 73, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 74, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 75, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 76, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 77, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 78, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 79, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 80, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 81, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 82, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 83, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 84, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 85, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 86, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 87, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 88, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 89, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 90, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 91, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 92, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 93, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 94, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 95, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 96, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 97, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 98, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 99, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 100, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 101, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 102, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 103, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 104, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 105, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 106, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 107, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 108, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 109, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 110, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 111, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 112, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 113, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 114, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 115, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 116, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 117, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 118, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 119, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 120, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 121, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 122, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 123, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 124, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 125, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 126, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 127, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 128, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 129, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 130, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 131, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 132, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 133, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 134, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 135, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 136, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 137, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 138, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 139, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 140, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 141, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 142, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 143, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 144, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 145, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 146, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 147, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 148, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 149, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 150, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 1, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 2, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 3, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 4, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 5, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 6, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 7, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 8, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 9, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 10, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 11, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 12, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 13, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 14, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 15, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 16, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 17, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 18, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 19, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 20, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 21, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 22, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 23, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 24, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 25, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 26, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 27, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 28, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 29, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 30, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 31, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 32, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 33, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 34, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 35, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 36, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 37, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 38, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 39, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 40, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 41, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 42, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 43, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 44, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 45, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 46, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 47, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 48, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 49, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 50, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 51, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 52, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 53, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 54, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 55, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 56, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 57, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 58, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 59, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 60, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 61, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 62, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 63, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 64, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 65, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 66, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 67, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 68, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 69, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 70, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 71, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 72, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 73, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 74, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 75, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 76, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 77, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 78, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 79, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 80, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 81, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 82, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 83, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 84, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 85, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 86, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 87, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 88, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 89, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 90, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 91, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 92, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 93, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 94, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 95, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 96, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 97, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 98, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 99, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 100, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 101, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 102, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 103, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 104, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 105, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 106, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 107, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 108, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 109, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 110, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 111, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 112, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 113, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 114, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 115, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 116, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 117, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 118, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 119, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 120, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 121, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 122, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 123, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 124, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 125, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 126, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 127, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 128, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 129, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 130, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 131, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 132, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 133, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 134, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 135, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 136, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 137, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 138, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 139, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 140, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 141, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 142, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 143, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 144, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 145, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 146, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 147, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 148, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 149, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 150, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 }
  ],
  darkness: [
    { node: 1, level: 1, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 2, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 3, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 4, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 5, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 6, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 7, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 8, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 9, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 10, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 11, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 12, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 13, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 14, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 15, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 16, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 17, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 18, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 19, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 20, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 21, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 22, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 23, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 24, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 25, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 26, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 27, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 28, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 29, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 30, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 31, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 32, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 33, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 34, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 35, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 36, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 37, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 38, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 39, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 40, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 41, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 42, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 43, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 44, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 45, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 46, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 47, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 48, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 49, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 50, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 51, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 52, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 53, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 54, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 55, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 56, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 57, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 58, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 59, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 60, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 61, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 62, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 63, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 64, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 65, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 66, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 67, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 68, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 69, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 70, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 71, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 72, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 73, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 74, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 75, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 76, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 77, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 78, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 79, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 80, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 81, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 82, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 83, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 84, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 85, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 86, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 87, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 88, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 89, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 90, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 91, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 92, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 93, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 94, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 95, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 96, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 97, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 98, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 99, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 100, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 101, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 102, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 103, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 104, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 105, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 106, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 107, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 108, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 109, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 110, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 111, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 112, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 113, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 114, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 115, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 116, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 117, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 118, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 119, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 120, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 121, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 122, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 123, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 124, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 125, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 126, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 127, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 128, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 129, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 130, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 131, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 132, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 133, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 134, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 135, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 136, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 137, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 138, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 139, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 140, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 141, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 142, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 143, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 144, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 145, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 146, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 147, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 148, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 149, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 150, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 1, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 2, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 3, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 4, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 5, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 6, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 7, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 8, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 9, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 10, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 11, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 12, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 13, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 14, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 15, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 16, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 17, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 18, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 19, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 20, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 21, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 22, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 23, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 24, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 25, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 26, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 27, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 28, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 29, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 30, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 31, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 32, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 33, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 34, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 35, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 36, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 37, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 38, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 39, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 40, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 41, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 42, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 43, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 44, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 45, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 46, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 47, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 48, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 49, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 50, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 51, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 52, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 53, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 54, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 55, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 56, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 57, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 58, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 59, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 60, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 61, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 62, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 63, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 64, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 65, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 66, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 67, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 68, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 69, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 70, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 71, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 72, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 73, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 74, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 75, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 76, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 77, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 78, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 79, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 80, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 81, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 82, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 83, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 84, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 85, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 86, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 87, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 88, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 89, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 90, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 91, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 92, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 93, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 94, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 95, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 96, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 97, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 98, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 99, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 100, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 101, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 102, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 103, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 104, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 105, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 106, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 107, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 108, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 109, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 110, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 111, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 112, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 113, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 114, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 115, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 116, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 117, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 118, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 119, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 120, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 121, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 122, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 123, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 124, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 125, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 126, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 127, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 128, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 129, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 130, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 131, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 132, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 133, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 134, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 135, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 136, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 137, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 138, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 139, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 140, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 141, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 142, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 143, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 144, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 145, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 146, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 147, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 148, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 149, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 150, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 1, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 2, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 3, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 4, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 5, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 6, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 7, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 8, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 9, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 10, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 11, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 12, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 13, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 14, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 15, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 16, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 17, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 18, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 19, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 20, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 21, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 22, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 23, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 24, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 25, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 26, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 27, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 28, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 29, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 30, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 31, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 32, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 33, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 34, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 35, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 36, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 37, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 38, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 39, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 40, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 41, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 42, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 43, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 44, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 45, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 46, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 47, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 48, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 49, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 50, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 51, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 52, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 53, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 54, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 55, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 56, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 57, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 58, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 59, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 60, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 61, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 62, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 63, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 64, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 65, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 66, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 67, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 68, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 69, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 70, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 71, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 72, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 73, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 74, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 75, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 76, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 77, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 78, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 79, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 80, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 81, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 82, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 83, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 84, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 85, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 86, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 87, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 88, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 89, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 90, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 91, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 92, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 93, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 94, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 95, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 96, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 97, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 98, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 99, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 100, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 101, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 102, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 103, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 104, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 105, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 106, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 107, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 108, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 109, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 110, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 111, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 112, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 113, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 114, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 115, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 116, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 117, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 118, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 119, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 120, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 121, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 122, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 123, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 124, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 125, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 126, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 127, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 128, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 129, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 130, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 131, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 132, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 133, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 134, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 135, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 136, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 137, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 138, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 139, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 140, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 141, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 142, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 143, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 144, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 145, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 146, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 147, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 148, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 149, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 150, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 }
  ],
  order: [
    { node: 1, level: 1, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 2, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 3, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 4, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 5, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 6, stones: 25, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 7, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 8, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 9, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 10, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 11, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 12, stones: 40, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 13, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 14, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 15, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 16, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 17, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 18, stones: 55, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 19, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 20, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 21, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 22, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 23, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 24, stones: 60, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 25, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 26, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 27, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 28, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 29, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 30, stones: 70, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 31, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 32, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 33, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 34, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 35, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 36, stones: 75, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 37, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 38, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 39, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 40, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 41, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 42, stones: 80, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 43, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 44, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 45, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 46, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 47, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 48, stones: 85, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 49, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 50, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 51, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 52, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 53, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 54, stones: 95, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 55, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 56, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 57, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 58, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 59, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 60, stones: 100, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 61, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 62, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 63, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 64, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 65, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 66, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 67, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 68, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 69, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 70, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 71, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 72, stones: 130, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 1, level: 73, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 74, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 75, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 76, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 77, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 78, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 79, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 80, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 81, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 82, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 83, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 84, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 85, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 86, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 87, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 88, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 89, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 90, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 1, level: 91, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 92, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 93, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 94, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 95, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 96, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 97, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 98, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 99, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 100, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 101, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 102, stones: 280, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 1, level: 103, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 104, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 105, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 106, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 107, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 108, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 109, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 110, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 111, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 112, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 113, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 114, stones: 360, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 115, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 116, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 117, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 118, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 119, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 120, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 1, level: 121, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 122, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 123, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 124, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 125, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 126, stones: 400, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 127, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 128, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 129, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 130, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 131, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 132, stones: 410, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 133, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 134, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 135, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 136, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 137, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 138, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 1, level: 139, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 140, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 141, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 142, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 143, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 144, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 1, level: 145, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 146, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 147, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 148, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 149, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 1, level: 150, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 1, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 2, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 3, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 4, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 5, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 6, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 7, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 8, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 9, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 10, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 11, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 12, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 13, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 14, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 15, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 16, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 17, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 18, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 19, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 20, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 21, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 22, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 23, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 24, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 25, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 26, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 27, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 28, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 29, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 30, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 31, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 32, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 33, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 34, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 35, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 36, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 37, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 38, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 39, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 40, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 41, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 42, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 43, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 44, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 45, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 46, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 47, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 48, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 49, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 50, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 51, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 52, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 53, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 54, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 55, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 56, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 57, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 58, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 59, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 60, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 61, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 62, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 63, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 64, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 65, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 66, stones: 115, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 67, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 68, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 69, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 70, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 71, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 72, stones: 130, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 73, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 74, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 75, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 76, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 77, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 78, stones: 150, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 79, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 80, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 81, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 82, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 83, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 84, stones: 180, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 2, level: 85, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 86, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 87, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 88, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 89, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 90, stones: 210, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 2, level: 91, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 92, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 93, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 94, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 95, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 96, stones: 240, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 97, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 98, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 99, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 100, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 101, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 102, stones: 280, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 103, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 104, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 105, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 106, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 107, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 108, stones: 320, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 109, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 110, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 111, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 112, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 113, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 114, stones: 360, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 2, level: 115, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 116, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 117, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 118, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 119, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 120, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 2, level: 121, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 122, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 123, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 124, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 125, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 126, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 127, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 128, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 129, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 130, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 131, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 132, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 133, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 134, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 135, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 136, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 137, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 138, stones: 420, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 2, level: 139, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 140, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 141, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 142, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 143, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 144, stones: 430, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 2, level: 145, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 146, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 147, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 148, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 149, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 2, level: 150, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 1, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 2, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 3, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 4, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 5, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 6, stones: 25, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 7, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 8, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 9, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 10, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 11, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 12, stones: 40, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 13, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 14, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 15, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 16, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 17, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 18, stones: 55, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 19, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 20, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 21, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 22, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 23, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 24, stones: 60, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 25, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 26, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 27, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 28, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 29, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 30, stones: 70, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 31, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 32, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 33, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 34, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 35, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 36, stones: 75, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 37, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 38, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 39, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 40, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 41, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 42, stones: 80, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 43, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 44, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 45, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 46, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 47, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 48, stones: 85, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 49, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 50, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 51, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 52, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 53, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 54, stones: 95, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 55, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 56, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 57, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 58, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 59, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 60, stones: 100, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 61, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 62, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 63, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 64, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 65, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 66, stones: 115, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 67, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 68, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 69, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 70, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 71, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 72, stones: 130, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 73, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 74, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 75, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 76, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 77, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 78, stones: 150, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 79, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 80, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 81, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 82, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 83, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 84, stones: 180, statDesc: 'Archers and Mages HP Boost', stat: 0.4 },
    { node: 3, level: 85, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 86, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 87, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 88, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 89, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 90, stones: 210, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.3 },
    { node: 3, level: 91, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 92, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 93, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 94, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 95, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 96, stones: 240, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 97, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 98, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 99, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 100, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 101, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 102, stones: 280, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 103, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 104, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 105, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 106, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 107, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 108, stones: 320, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 109, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 110, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 111, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 112, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 113, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 114, stones: 360, statDesc: 'Infantry and Cavalry Attack Boost', stat: 0.4 },
    { node: 3, level: 115, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 116, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 117, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 118, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 119, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 120, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.3 },
    { node: 3, level: 121, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 122, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 123, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 124, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 125, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 126, stones: 400, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 127, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 128, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 129, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 130, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 131, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 132, stones: 410, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 133, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 134, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 135, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 136, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 137, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 138, stones: 420, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.4 },
    { node: 3, level: 139, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 140, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 141, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 142, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 143, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 144, stones: 430, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.4 },
    { node: 3, level: 145, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 146, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 147, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 148, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 149, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 },
    { node: 3, level: 150, stones: 440, statDesc: 'Damage taken reduced when attacking', stat: 0.3 }
  ],
  earth: [
    { node: 1, level: 1, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 2, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 3, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 4, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 5, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 6, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 7, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 8, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 9, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 10, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 11, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 12, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 13, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 14, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 15, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 16, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 17, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 18, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 19, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 20, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 21, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 22, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 23, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 24, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 25, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 26, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 27, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 28, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 29, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 30, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 31, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 32, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 33, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 34, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 35, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 36, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 37, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 38, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 39, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 40, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 41, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 42, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 43, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 44, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 45, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 46, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 47, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 48, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 49, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 50, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 51, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 52, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 53, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 54, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 55, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 56, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 57, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 58, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 59, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 60, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 61, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 62, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 63, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 64, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 65, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 66, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 67, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 68, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 69, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 70, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 71, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 72, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 73, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 74, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 75, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 76, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 77, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 78, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 79, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 80, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 81, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 82, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 83, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 84, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 85, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 86, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 87, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 88, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 89, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 90, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 91, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 92, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 93, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 94, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 95, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 96, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 97, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 98, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 99, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 100, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 101, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 102, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 103, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 104, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 105, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 106, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 107, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 108, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 109, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 110, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 111, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 112, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 113, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 114, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 115, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 116, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 117, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 118, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 119, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 120, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 121, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 122, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 123, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 124, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 125, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 126, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 127, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 128, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 129, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 130, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 131, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 132, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 133, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 134, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 135, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 136, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 137, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 138, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 139, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 140, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 141, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 142, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 143, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 144, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 145, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 146, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 147, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 148, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 149, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 150, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 1, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 2, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 3, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 4, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 5, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 6, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 7, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 8, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 9, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 10, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 11, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 12, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 13, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 14, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 15, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 16, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 17, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 18, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 19, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 20, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 21, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 22, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 23, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 24, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 25, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 26, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 27, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 28, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 29, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 30, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 31, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 32, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 33, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 34, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 35, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 36, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 37, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 38, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 39, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 40, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 41, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 42, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 43, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 44, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 45, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 46, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 47, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 48, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 49, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 50, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 51, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 52, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 53, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 54, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 55, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 56, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 57, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 58, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 59, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 60, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 61, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 62, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 63, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 64, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 65, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 66, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 67, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 68, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 69, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 70, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 71, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 72, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 73, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 74, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 75, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 76, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 77, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 78, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 79, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 80, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 81, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 82, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 83, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 84, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 85, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 86, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 87, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 88, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 89, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 90, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 91, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 92, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 93, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 94, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 95, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 96, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 97, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 98, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 99, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 100, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 101, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 102, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 103, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 104, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 105, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 106, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 107, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 108, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 109, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 110, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 111, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 112, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 113, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 114, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 115, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 116, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 117, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 118, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 119, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 120, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 121, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 122, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 123, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 124, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 125, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 126, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 127, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 128, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 129, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 130, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 131, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 132, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 133, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 134, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 135, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 136, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 137, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 138, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 139, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 140, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 141, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 142, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 143, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 144, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 145, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 146, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 147, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 148, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 149, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 150, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 1, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 2, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 3, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 4, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 5, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 6, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 7, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 8, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 9, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 10, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 11, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 12, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 13, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 14, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 15, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 16, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 17, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 18, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 19, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 20, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 21, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 22, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 23, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 24, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 25, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 26, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 27, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 28, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 29, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 30, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 31, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 32, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 33, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 34, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 35, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 36, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 37, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 38, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 39, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 40, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 41, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 42, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 43, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 44, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 45, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 46, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 47, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 48, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 49, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 50, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 51, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 52, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 53, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 54, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 55, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 56, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 57, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 58, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 59, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 60, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 61, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 62, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 63, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 64, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 65, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 66, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 67, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 68, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 69, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 70, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 71, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 72, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 73, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 74, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 75, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 76, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 77, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 78, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 79, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 80, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 81, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 82, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 83, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 84, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 85, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 86, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 87, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 88, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 89, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 90, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 91, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 92, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 93, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 94, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 95, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 96, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 97, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 98, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 99, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 100, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 101, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 102, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 103, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 104, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 105, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 106, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 107, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 108, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 109, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 110, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 111, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 112, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 113, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 114, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 115, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 116, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 117, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 118, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 119, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 120, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 121, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 122, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 123, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 124, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 125, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 126, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 127, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 128, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 129, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 130, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 131, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 132, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 133, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 134, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 135, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 136, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 137, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 138, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 139, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 140, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 141, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 142, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 143, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 144, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 145, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 146, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 147, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 148, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 149, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 150, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 }
  ],
  wrath: [
    { node: 1, level: 1, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 2, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 3, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 4, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 5, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 6, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 7, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 8, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 9, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 10, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 11, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 12, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 13, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 14, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 15, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 16, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 17, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 18, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 19, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 20, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 21, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 22, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 23, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 24, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 25, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 26, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 27, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 28, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 29, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 30, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 31, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 32, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 33, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 34, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 35, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 36, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 37, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 38, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 39, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 40, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 41, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 42, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 43, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 44, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 45, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 46, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 47, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 48, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 49, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 50, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 51, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 52, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 53, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 54, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 55, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 56, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 57, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 58, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 59, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 60, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 61, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 62, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 63, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 64, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 65, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 66, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 67, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 68, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 69, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 70, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 71, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 72, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 73, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 74, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 75, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 76, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 77, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 78, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 79, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 80, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 81, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 82, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 83, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 84, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 85, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 86, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 87, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 88, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 89, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 90, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 91, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 92, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 93, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 94, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 95, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 96, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 97, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 98, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 99, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 100, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 101, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 102, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 103, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 104, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 105, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 106, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 107, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 108, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 109, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 110, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 111, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 112, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 113, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 114, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 115, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 116, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 117, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 118, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 119, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 120, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 121, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 122, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 123, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 124, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 125, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 126, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 127, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 128, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 129, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 130, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 131, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 132, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 133, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 134, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 135, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 136, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 137, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 138, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 139, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 140, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 141, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 142, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 143, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 144, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 145, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 146, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 147, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 148, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 149, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 150, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 1, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 2, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 3, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 4, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 5, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 6, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 7, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 8, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 9, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 10, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 11, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 12, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 13, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 14, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 15, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 16, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 17, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 18, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 19, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 20, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 21, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 22, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 23, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 24, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 25, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 26, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 27, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 28, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 29, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 30, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 31, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 32, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 33, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 34, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 35, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 36, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 37, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 38, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 39, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 40, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 41, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 42, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 43, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 44, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 45, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 46, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 47, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 48, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 49, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 50, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 51, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 52, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 53, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 54, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 55, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 56, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 57, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 58, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 59, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 60, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 61, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 62, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 63, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 64, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 65, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 66, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 67, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 68, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 69, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 70, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 71, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 72, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 73, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 74, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 75, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 76, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 77, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 78, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 79, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 80, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 81, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 82, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 83, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 84, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 85, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 86, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 87, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 88, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 89, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 90, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 91, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 92, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 93, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 94, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 95, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 96, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 97, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 98, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 99, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 100, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 101, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 102, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 103, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 104, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 105, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 106, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 107, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 108, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 109, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 110, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 111, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 112, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 113, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 114, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 115, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 116, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 117, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 118, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 119, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 120, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 121, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 122, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 123, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 124, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 125, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 126, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 127, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 128, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 129, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 130, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 131, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 132, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 133, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 134, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 135, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 136, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 137, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 138, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 139, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 140, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 141, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 142, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 143, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 144, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 145, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 146, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 147, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 148, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 149, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 150, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 1, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 2, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 3, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 4, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 5, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 6, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 7, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 8, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 9, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 10, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 11, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 12, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 13, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 14, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 15, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 16, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 17, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 18, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 19, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 20, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 21, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 22, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 23, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 24, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 25, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 26, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 27, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 28, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 29, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 30, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 31, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 32, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 33, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 34, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 35, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 36, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 37, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 38, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 39, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 40, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 41, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 42, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 43, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 44, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 45, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 46, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 47, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 48, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 49, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 50, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 51, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 52, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 53, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 54, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 55, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 56, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 57, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 58, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 59, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 60, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 61, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 62, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 63, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 64, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 65, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 66, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 67, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 68, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 69, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 70, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 71, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 72, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 73, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 74, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 75, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 76, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 77, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 78, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 79, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 80, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 81, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 82, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 83, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 84, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 85, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 86, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 87, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 88, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 89, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 90, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 91, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 92, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 93, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 94, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 95, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 96, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 97, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 98, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 99, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 100, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 101, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 102, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 103, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 104, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 105, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 106, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 107, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 108, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 109, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 110, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 111, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 112, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 113, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 114, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 115, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 116, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 117, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 118, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 119, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 120, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 121, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 122, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 123, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 124, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 125, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 126, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 127, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 128, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 129, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 130, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 131, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 132, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 133, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 134, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 135, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 136, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 137, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 138, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 139, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 140, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 141, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 142, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 143, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 144, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 145, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 146, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 147, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 148, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 149, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 150, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 }
  ],
  guard: [
    { node: 1, level: 1, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 2, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 3, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 4, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 5, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 6, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 7, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 8, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 9, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 10, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 11, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 12, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 13, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 14, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 15, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 16, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 17, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 18, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 19, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 20, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 21, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 22, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 23, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 24, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 25, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 26, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 27, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 28, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 29, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 30, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 31, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 32, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 33, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 34, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 35, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 36, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 1, level: 37, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 38, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 39, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 40, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 41, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 42, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 43, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 44, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 45, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 46, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 47, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 48, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 1, level: 49, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 50, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 51, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 52, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 53, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 54, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 1, level: 55, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 56, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 57, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 58, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 59, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 60, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 61, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 62, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 63, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 64, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 65, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 66, stones: 440, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 67, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 68, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 69, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 70, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 71, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 72, stones: 490, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 73, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 74, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 75, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 76, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 77, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 78, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 1, level: 79, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 80, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 81, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 82, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 83, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 84, stones: 635, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 85, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 86, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 87, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 88, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 89, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 90, stones: 710, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 1, level: 91, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 92, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 93, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 94, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 95, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 96, stones: 800, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 97, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 98, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 99, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 100, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 101, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 102, stones: 900, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 103, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 104, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 105, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 106, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 107, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 108, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 1, level: 109, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 110, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 111, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 112, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 113, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 114, stones: 1100, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 115, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 116, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 117, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 118, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 119, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 120, stones: 1200, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 1, level: 121, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 122, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 123, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 124, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 125, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 126, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 1, level: 127, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 128, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 129, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 130, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 131, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 132, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 1, level: 133, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 134, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 135, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 136, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 137, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 138, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 1, level: 139, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 140, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 141, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 142, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 143, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 144, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 1, level: 145, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 146, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 147, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 148, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 149, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 1, level: 150, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 1, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 2, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 3, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 4, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 5, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 6, stones: 65, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 7, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 8, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 9, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 10, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 11, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 12, stones: 105, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 13, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 14, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 15, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 16, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 17, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 18, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 19, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 20, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 21, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 22, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 23, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 24, stones: 180, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 25, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 26, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 27, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 28, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 29, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 30, stones: 205, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 31, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 32, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 33, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 34, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 35, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 36, stones: 235, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 2, level: 37, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 38, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 39, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 40, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 41, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 42, stones: 270, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 43, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 44, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 45, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 46, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 47, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 48, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 2, level: 49, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 50, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 51, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 52, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 53, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 54, stones: 350, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 2, level: 55, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 56, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 57, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 58, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 59, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 60, stones: 390, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 61, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 62, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 63, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 64, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 65, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 66, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 67, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 68, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 69, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 70, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 71, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 72, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 73, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 74, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 75, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 76, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 77, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 78, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 2, level: 79, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 80, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 81, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 82, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 83, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 84, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 85, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 86, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 87, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 88, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 89, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 90, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 2, level: 91, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 92, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 93, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 94, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 95, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 96, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 97, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 98, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 99, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 100, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 101, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 102, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 103, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 104, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 105, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 106, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 107, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 108, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 2, level: 109, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 110, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 111, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 112, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 113, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 114, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 115, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 116, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 117, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 118, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 119, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 120, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 2, level: 121, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 122, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 123, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 124, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 125, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 126, stones: 1250, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 2, level: 127, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 128, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 129, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 130, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 131, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 132, stones: 1300, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 2, level: 133, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 134, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 135, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 136, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 137, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 138, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 2, level: 139, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 140, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 141, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 142, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 143, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 144, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 2, level: 145, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 146, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 147, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 148, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 149, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 2, level: 150, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 1, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 2, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 3, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 4, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 5, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 6, stones: 65, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 7, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 8, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 9, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 10, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 11, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 12, stones: 105, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 13, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 14, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 15, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 16, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 17, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 18, stones: 145, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 19, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 20, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 21, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 22, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 23, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 24, stones: 180, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 25, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 26, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 27, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 28, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 29, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 30, stones: 205, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 31, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 32, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 33, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 34, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 35, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 36, stones: 235, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.5 },
    { node: 3, level: 37, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 38, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 39, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 40, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 41, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 42, stones: 270, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 43, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 44, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 45, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 46, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 47, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 48, stones: 310, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.3 },
    { node: 3, level: 49, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 50, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 51, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 52, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 53, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 54, stones: 350, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.5 },
    { node: 3, level: 55, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 56, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 57, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 58, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 59, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 60, stones: 390, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 61, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 62, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 63, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 64, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 65, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 66, stones: 440, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 67, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 68, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 69, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 70, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 71, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 72, stones: 490, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 73, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 74, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 75, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 76, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 77, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 78, stones: 550, statDesc: 'Critical Strike Damage Boost', stat: 0.6 },
    { node: 3, level: 79, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 80, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 81, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 82, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 83, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 84, stones: 635, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 85, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 86, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 87, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 88, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 89, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 90, stones: 710, statDesc: 'Archers and Mages Damage Dealt Boost', stat: 0.4 },
    { node: 3, level: 91, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 92, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 93, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 94, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 95, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 96, stones: 800, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 97, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 98, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 99, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 100, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 101, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 102, stones: 900, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 103, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 104, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 105, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 106, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 107, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 108, stones: 1000, statDesc: 'Critical Strike Rate Taken Reduction', stat: 0.6 },
    { node: 3, level: 109, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 110, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 111, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 112, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 113, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 114, stones: 1100, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 115, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 116, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 117, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 118, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 119, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 120, stones: 1200, statDesc: 'Infantry and Cavalry Damage Taken Reduction', stat: 0.4 },
    { node: 3, level: 121, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 122, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 123, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 124, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 125, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 126, stones: 1250, statDesc: 'Infantry and Cavalry HP Boost', stat: 0.6 },
    { node: 3, level: 127, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 128, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 129, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 130, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 131, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 132, stones: 1300, statDesc: 'Increase the Attack of Archers and Mages', stat: 0.6 },
    { node: 3, level: 133, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 134, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 135, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 136, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 137, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 138, stones: 1350, statDesc: 'Critical Strike Rate Boost', stat: 0.3 },
    { node: 3, level: 139, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 140, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 141, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 142, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 143, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 144, stones: 1400, statDesc: 'Damage taken reduced when attacking', stat: 0.4 },
    { node: 3, level: 145, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 146, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 147, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 148, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 149, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 },
    { node: 3, level: 150, stones: 1450, statDesc: 'Damage Boost when attacking', stat: 0.4 }
  ]
}

export const totemSkill = {
  blue: [
    { level: 1, quantity: 150 },
    { level: 2, quantity: 175 },
    { level: 3, quantity: 200 },
    { level: 4, quantity: 225 },
    { level: 5, quantity: 250 },
    { level: 6, quantity: 350 },
    { level: 7, quantity: 425 },
    { level: 8, quantity: 550 },
    { level: 9, quantity: 625 },
    { level: 10, quantity: 700 }
  ],
  purple: [
    { level: 1, quantity: 45 },
    { level: 2, quantity: 55 },
    { level: 3, quantity: 96 },
    { level: 4, quantity: 105 },
    { level: 5, quantity: 145 },
    { level: 6, quantity: 155 },
    { level: 7, quantity: 205 },
    { level: 8, quantity: 220 },
    { level: 9, quantity: 265 },
    { level: 10, quantity: 285 },
    { level: 11, quantity: 390 },
    { level: 12, quantity: 410 },
    { level: 13, quantity: 440 },
    { level: 14, quantity: 460 },
    { level: 15, quantity: 490 },
    { level: 16, quantity: 510 },
    { level: 17, quantity: 515 },
    { level: 18, quantity: 535 },
    { level: 19, quantity: 540 },
    { level: 20, quantity: 560 },
    { level: 21, quantity: 590 },
    { level: 22, quantity: 620 },
    { level: 23, quantity: 650 },
    { level: 24, quantity: 680 },
    { level: 25, quantity: 0 },
    { level: 26, quantity: 0 },
    { level: 27, quantity: 0 },
    { level: 28, quantity: 0 },
    { level: 29, quantity: 0 },
    { level: 30, quantity: 0 }
  ],
  gold: [
    { level: 1, quantity: 15 },
    { level: 2, quantity: 25 },
    { level: 3, quantity: 35 },
    { level: 4, quantity: 45 },
    { level: 5, quantity: 55 },
    { level: 6, quantity: 65 },
    { level: 7, quantity: 85 },
    { level: 8, quantity: 95 },
    { level: 9, quantity: 120 },
    { level: 10, quantity: 130 },
    { level: 11, quantity: 170 },
    { level: 12, quantity: 180 },
    { level: 13, quantity: 195 },
    { level: 14, quantity: 205 },
    { level: 15, quantity: 220 },
    { level: 16, quantity: 230 },
    { level: 17, quantity: 265 },
    { level: 18, quantity: 285 },
    { level: 19, quantity: 315 },
    { level: 20, quantity: 335 },
    { level: 21, quantity: 360 },
    { level: 22, quantity: 390 },
    { level: 23, quantity: 440 },
    { level: 24, quantity: 490 },
    { level: 25, quantity: 540 },
    { level: 26, quantity: 590 },
    { level: 27, quantity: 650 },
    { level: 28, quantity: 750 },
    { level: 29, quantity: 850 },
    { level: 30, quantity: 1000 }
  ]
}

export const totemStones = {
  blue: [
    { level: 1, quantity: 50 },
    { level: 2, quantity: 50 },
    { level: 3, quantity: 50 },
    { level: 4, quantity: 50 },
    { level: 5, quantity: 50 },
    { level: 6, quantity: 50 },
    { level: 7, quantity: 130 },
    { level: 8, quantity: 130 },
    { level: 9, quantity: 130 },
    { level: 10, quantity: 130 },
    { level: 11, quantity: 130 },
    { level: 12, quantity: 130 },
    { level: 13, quantity: 186 },
    { level: 14, quantity: 186 },
    { level: 15, quantity: 186 },
    { level: 16, quantity: 186 },
    { level: 17, quantity: 186 },
    { level: 18, quantity: 186 },
    { level: 19, quantity: 195 },
    { level: 20, quantity: 195 },
    { level: 21, quantity: 195 },
    { level: 22, quantity: 195 },
    { level: 23, quantity: 195 },
    { level: 24, quantity: 195 },
    { level: 25, quantity: 204 },
    { level: 26, quantity: 204 },
    { level: 27, quantity: 204 },
    { level: 28, quantity: 204 },
    { level: 29, quantity: 204 },
    { level: 30, quantity: 204 },
    { level: 31, quantity: 213 },
    { level: 32, quantity: 213 },
    { level: 33, quantity: 213 },
    { level: 34, quantity: 213 },
    { level: 35, quantity: 213 },
    { level: 36, quantity: 213 },
    { level: 37, quantity: 223 },
    { level: 38, quantity: 223 },
    { level: 39, quantity: 223 },
    { level: 40, quantity: 223 },
    { level: 41, quantity: 223 },
    { level: 42, quantity: 223 },
    { level: 43, quantity: 233 },
    { level: 44, quantity: 233 },
    { level: 45, quantity: 233 },
    { level: 46, quantity: 233 },
    { level: 47, quantity: 233 },
    { level: 48, quantity: 233 },
    { level: 49, quantity: 244 },
    { level: 50, quantity: 244 },
    { level: 51, quantity: 244 },
    { level: 52, quantity: 244 },
    { level: 53, quantity: 244 },
    { level: 54, quantity: 244 },
    { level: 55, quantity: 255 },
    { level: 56, quantity: 255 },
    { level: 57, quantity: 255 },
    { level: 58, quantity: 255 },
    { level: 59, quantity: 255 },
    { level: 60, quantity: 255 },
    { level: 61, quantity: 358 },
    { level: 62, quantity: 358 },
    { level: 63, quantity: 358 },
    { level: 64, quantity: 358 },
    { level: 65, quantity: 358 },
    { level: 66, quantity: 358 },
    { level: 67, quantity: 387 },
    { level: 68, quantity: 387 },
    { level: 69, quantity: 387 },
    { level: 70, quantity: 387 },
    { level: 71, quantity: 387 },
    { level: 72, quantity: 387 },
    { level: 73, quantity: 418 },
    { level: 74, quantity: 418 },
    { level: 75, quantity: 418 },
    { level: 76, quantity: 418 },
    { level: 77, quantity: 418 },
    { level: 78, quantity: 418 },
    { level: 79, quantity: 451 },
    { level: 80, quantity: 451 },
    { level: 81, quantity: 451 },
    { level: 82, quantity: 451 },
    { level: 83, quantity: 451 },
    { level: 84, quantity: 451 },
    { level: 85, quantity: 487 },
    { level: 86, quantity: 487 },
    { level: 87, quantity: 487 },
    { level: 88, quantity: 487 },
    { level: 89, quantity: 487 },
    { level: 90, quantity: 487 },
    { level: 91, quantity: 526 },
    { level: 92, quantity: 526 },
    { level: 93, quantity: 526 },
    { level: 94, quantity: 526 },
    { level: 95, quantity: 526 },
    { level: 96, quantity: 526 },
    { level: 97, quantity: 568 },
    { level: 98, quantity: 568 },
    { level: 99, quantity: 568 },
    { level: 100, quantity: 568 },
    { level: 101, quantity: 568 },
    { level: 102, quantity: 568 },
    { level: 103, quantity: 614 },
    { level: 104, quantity: 614 },
    { level: 105, quantity: 614 },
    { level: 106, quantity: 614 },
    { level: 107, quantity: 614 },
    { level: 108, quantity: 614 },
    { level: 109, quantity: 663 },
    { level: 110, quantity: 663 },
    { level: 111, quantity: 663 },
    { level: 112, quantity: 663 },
    { level: 113, quantity: 663 },
    { level: 114, quantity: 663 },
    { level: 115, quantity: 716 },
    { level: 116, quantity: 716 },
    { level: 117, quantity: 716 },
    { level: 118, quantity: 716 },
    { level: 119, quantity: 716 },
    { level: 120, quantity: 716 }
  ],
  purple: [
    { level: 1, quantity: 25 },
    { level: 2, quantity: 25 },
    { level: 3, quantity: 25 },
    { level: 4, quantity: 25 },
    { level: 5, quantity: 25 },
    { level: 6, quantity: 25 },
    { level: 7, quantity: 25 },
    { level: 8, quantity: 25 },
    { level: 9, quantity: 25 },
    { level: 10, quantity: 25 },
    { level: 11, quantity: 25 },
    { level: 12, quantity: 25 },
    { level: 13, quantity: 25 },
    { level: 14, quantity: 25 },
    { level: 15, quantity: 25 },
    { level: 16, quantity: 25 },
    { level: 17, quantity: 25 },
    { level: 18, quantity: 25 },
    { level: 19, quantity: 40 },
    { level: 20, quantity: 40 },
    { level: 21, quantity: 40 },
    { level: 22, quantity: 40 },
    { level: 23, quantity: 40 },
    { level: 24, quantity: 40 },
    { level: 25, quantity: 40 },
    { level: 26, quantity: 40 },
    { level: 27, quantity: 40 },
    { level: 28, quantity: 40 },
    { level: 29, quantity: 40 },
    { level: 30, quantity: 40 },
    { level: 31, quantity: 40 },
    { level: 32, quantity: 40 },
    { level: 33, quantity: 40 },
    { level: 34, quantity: 40 },
    { level: 35, quantity: 40 },
    { level: 36, quantity: 40 },
    { level: 37, quantity: 55 },
    { level: 38, quantity: 55 },
    { level: 39, quantity: 55 },
    { level: 40, quantity: 55 },
    { level: 41, quantity: 55 },
    { level: 42, quantity: 55 },
    { level: 43, quantity: 55 },
    { level: 44, quantity: 55 },
    { level: 45, quantity: 55 },
    { level: 46, quantity: 55 },
    { level: 47, quantity: 55 },
    { level: 48, quantity: 55 },
    { level: 49, quantity: 55 },
    { level: 50, quantity: 55 },
    { level: 51, quantity: 55 },
    { level: 52, quantity: 55 },
    { level: 53, quantity: 55 },
    { level: 54, quantity: 55 },
    { level: 55, quantity: 60 },
    { level: 56, quantity: 60 },
    { level: 57, quantity: 60 },
    { level: 58, quantity: 60 },
    { level: 59, quantity: 60 },
    { level: 60, quantity: 60 },
    { level: 61, quantity: 60 },
    { level: 62, quantity: 60 },
    { level: 63, quantity: 60 },
    { level: 64, quantity: 60 },
    { level: 65, quantity: 60 },
    { level: 66, quantity: 60 },
    { level: 67, quantity: 60 },
    { level: 68, quantity: 60 },
    { level: 69, quantity: 60 },
    { level: 70, quantity: 60 },
    { level: 71, quantity: 60 },
    { level: 72, quantity: 60 },
    { level: 73, quantity: 70 },
    { level: 74, quantity: 70 },
    { level: 75, quantity: 70 },
    { level: 76, quantity: 70 },
    { level: 77, quantity: 70 },
    { level: 78, quantity: 70 },
    { level: 79, quantity: 70 },
    { level: 80, quantity: 70 },
    { level: 81, quantity: 70 },
    { level: 82, quantity: 70 },
    { level: 83, quantity: 70 },
    { level: 84, quantity: 70 },
    { level: 85, quantity: 70 },
    { level: 86, quantity: 70 },
    { level: 87, quantity: 70 },
    { level: 88, quantity: 70 },
    { level: 89, quantity: 70 },
    { level: 90, quantity: 70 },
    { level: 91, quantity: 75 },
    { level: 92, quantity: 75 },
    { level: 93, quantity: 75 },
    { level: 94, quantity: 75 },
    { level: 95, quantity: 75 },
    { level: 96, quantity: 75 },
    { level: 97, quantity: 75 },
    { level: 98, quantity: 75 },
    { level: 99, quantity: 75 },
    { level: 100, quantity: 75 },
    { level: 101, quantity: 75 },
    { level: 102, quantity: 75 },
    { level: 103, quantity: 75 },
    { level: 104, quantity: 75 },
    { level: 105, quantity: 75 },
    { level: 106, quantity: 75 },
    { level: 107, quantity: 75 },
    { level: 108, quantity: 75 },
    { level: 109, quantity: 80 },
    { level: 110, quantity: 80 },
    { level: 111, quantity: 80 },
    { level: 112, quantity: 80 },
    { level: 113, quantity: 80 },
    { level: 114, quantity: 80 },
    { level: 115, quantity: 80 },
    { level: 116, quantity: 80 },
    { level: 117, quantity: 80 },
    { level: 118, quantity: 80 },
    { level: 119, quantity: 80 },
    { level: 120, quantity: 80 },
    { level: 121, quantity: 80 },
    { level: 122, quantity: 80 },
    { level: 123, quantity: 80 },
    { level: 124, quantity: 80 },
    { level: 125, quantity: 80 },
    { level: 126, quantity: 80 },
    { level: 127, quantity: 85 },
    { level: 128, quantity: 85 },
    { level: 129, quantity: 85 },
    { level: 130, quantity: 85 },
    { level: 131, quantity: 85 },
    { level: 132, quantity: 85 },
    { level: 133, quantity: 85 },
    { level: 134, quantity: 85 },
    { level: 135, quantity: 85 },
    { level: 136, quantity: 85 },
    { level: 137, quantity: 85 },
    { level: 138, quantity: 85 },
    { level: 139, quantity: 85 },
    { level: 140, quantity: 85 },
    { level: 141, quantity: 85 },
    { level: 142, quantity: 85 },
    { level: 143, quantity: 85 },
    { level: 144, quantity: 85 },
    { level: 145, quantity: 95 },
    { level: 146, quantity: 95 },
    { level: 147, quantity: 95 },
    { level: 148, quantity: 95 },
    { level: 149, quantity: 95 },
    { level: 150, quantity: 95 },
    { level: 151, quantity: 95 },
    { level: 152, quantity: 95 },
    { level: 153, quantity: 95 },
    { level: 154, quantity: 95 },
    { level: 155, quantity: 95 },
    { level: 156, quantity: 95 },
    { level: 157, quantity: 95 },
    { level: 158, quantity: 95 },
    { level: 159, quantity: 95 },
    { level: 160, quantity: 95 },
    { level: 161, quantity: 95 },
    { level: 162, quantity: 95 },
    { level: 163, quantity: 100 },
    { level: 164, quantity: 100 },
    { level: 165, quantity: 100 },
    { level: 166, quantity: 100 },
    { level: 167, quantity: 100 },
    { level: 168, quantity: 100 },
    { level: 169, quantity: 100 },
    { level: 170, quantity: 100 },
    { level: 171, quantity: 100 },
    { level: 172, quantity: 100 },
    { level: 173, quantity: 100 },
    { level: 174, quantity: 100 },
    { level: 175, quantity: 100 },
    { level: 176, quantity: 100 },
    { level: 177, quantity: 100 },
    { level: 178, quantity: 100 },
    { level: 179, quantity: 100 },
    { level: 180, quantity: 100 },
    { level: 181, quantity: 115 },
    { level: 182, quantity: 115 },
    { level: 183, quantity: 115 },
    { level: 184, quantity: 115 },
    { level: 185, quantity: 115 },
    { level: 186, quantity: 115 },
    { level: 187, quantity: 115 },
    { level: 188, quantity: 115 },
    { level: 189, quantity: 115 },
    { level: 190, quantity: 115 },
    { level: 191, quantity: 115 },
    { level: 192, quantity: 115 },
    { level: 193, quantity: 115 },
    { level: 194, quantity: 115 },
    { level: 195, quantity: 115 },
    { level: 196, quantity: 115 },
    { level: 197, quantity: 115 },
    { level: 198, quantity: 115 },
    { level: 199, quantity: 130 },
    { level: 200, quantity: 130 },
    { level: 201, quantity: 130 },
    { level: 202, quantity: 130 },
    { level: 203, quantity: 130 },
    { level: 204, quantity: 130 },
    { level: 205, quantity: 130 },
    { level: 206, quantity: 130 },
    { level: 207, quantity: 130 },
    { level: 208, quantity: 130 },
    { level: 209, quantity: 130 },
    { level: 210, quantity: 130 },
    { level: 211, quantity: 130 },
    { level: 212, quantity: 130 },
    { level: 213, quantity: 130 },
    { level: 214, quantity: 130 },
    { level: 215, quantity: 130 },
    { level: 216, quantity: 130 },
    { level: 217, quantity: 150 },
    { level: 218, quantity: 150 },
    { level: 219, quantity: 150 },
    { level: 220, quantity: 150 },
    { level: 221, quantity: 150 },
    { level: 222, quantity: 150 },
    { level: 223, quantity: 150 },
    { level: 224, quantity: 150 },
    { level: 225, quantity: 150 },
    { level: 226, quantity: 150 },
    { level: 227, quantity: 150 },
    { level: 228, quantity: 150 },
    { level: 229, quantity: 150 },
    { level: 230, quantity: 150 },
    { level: 231, quantity: 150 },
    { level: 232, quantity: 150 },
    { level: 233, quantity: 150 },
    { level: 234, quantity: 150 },
    { level: 235, quantity: 180 },
    { level: 236, quantity: 180 },
    { level: 237, quantity: 180 },
    { level: 238, quantity: 180 },
    { level: 239, quantity: 180 },
    { level: 240, quantity: 180 },
    { level: 241, quantity: 180 },
    { level: 242, quantity: 180 },
    { level: 243, quantity: 180 },
    { level: 244, quantity: 180 },
    { level: 245, quantity: 180 },
    { level: 246, quantity: 180 },
    { level: 247, quantity: 180 },
    { level: 248, quantity: 180 },
    { level: 249, quantity: 180 },
    { level: 250, quantity: 180 },
    { level: 251, quantity: 180 },
    { level: 252, quantity: 180 },
    { level: 253, quantity: 210 },
    { level: 254, quantity: 210 },
    { level: 255, quantity: 210 },
    { level: 256, quantity: 210 },
    { level: 257, quantity: 210 },
    { level: 258, quantity: 210 },
    { level: 259, quantity: 210 },
    { level: 260, quantity: 210 },
    { level: 261, quantity: 210 },
    { level: 262, quantity: 210 },
    { level: 263, quantity: 210 },
    { level: 264, quantity: 210 },
    { level: 265, quantity: 210 },
    { level: 266, quantity: 210 },
    { level: 267, quantity: 210 },
    { level: 268, quantity: 210 },
    { level: 269, quantity: 210 },
    { level: 270, quantity: 210 },
    { level: 271, quantity: 240 },
    { level: 272, quantity: 240 },
    { level: 273, quantity: 240 },
    { level: 274, quantity: 240 },
    { level: 275, quantity: 240 },
    { level: 276, quantity: 240 },
    { level: 277, quantity: 240 },
    { level: 278, quantity: 240 },
    { level: 279, quantity: 240 },
    { level: 280, quantity: 240 },
    { level: 281, quantity: 240 },
    { level: 282, quantity: 240 },
    { level: 283, quantity: 240 },
    { level: 284, quantity: 240 },
    { level: 285, quantity: 240 },
    { level: 286, quantity: 240 },
    { level: 287, quantity: 240 },
    { level: 288, quantity: 240 },
    { level: 289, quantity: 280 },
    { level: 290, quantity: 280 },
    { level: 291, quantity: 280 },
    { level: 292, quantity: 280 },
    { level: 293, quantity: 280 },
    { level: 294, quantity: 280 },
    { level: 295, quantity: 280 },
    { level: 296, quantity: 280 },
    { level: 297, quantity: 280 },
    { level: 298, quantity: 280 },
    { level: 299, quantity: 280 },
    { level: 300, quantity: 280 },
    { level: 301, quantity: 280 },
    { level: 302, quantity: 280 },
    { level: 303, quantity: 280 },
    { level: 304, quantity: 280 },
    { level: 305, quantity: 280 },
    { level: 306, quantity: 280 },
    { level: 307, quantity: 320 },
    { level: 308, quantity: 320 },
    { level: 309, quantity: 320 },
    { level: 310, quantity: 320 },
    { level: 311, quantity: 320 },
    { level: 312, quantity: 320 },
    { level: 313, quantity: 320 },
    { level: 314, quantity: 320 },
    { level: 315, quantity: 320 },
    { level: 316, quantity: 320 },
    { level: 317, quantity: 320 },
    { level: 318, quantity: 320 },
    { level: 319, quantity: 320 },
    { level: 320, quantity: 320 },
    { level: 321, quantity: 320 },
    { level: 322, quantity: 320 },
    { level: 323, quantity: 320 },
    { level: 324, quantity: 320 },
    { level: 325, quantity: 360 },
    { level: 326, quantity: 360 },
    { level: 327, quantity: 360 },
    { level: 328, quantity: 360 },
    { level: 329, quantity: 360 },
    { level: 330, quantity: 360 },
    { level: 331, quantity: 360 },
    { level: 332, quantity: 360 },
    { level: 333, quantity: 360 },
    { level: 334, quantity: 360 },
    { level: 335, quantity: 360 },
    { level: 336, quantity: 360 },
    { level: 337, quantity: 360 },
    { level: 338, quantity: 360 },
    { level: 339, quantity: 360 },
    { level: 340, quantity: 360 },
    { level: 341, quantity: 360 },
    { level: 342, quantity: 360 },
    { level: 343, quantity: 390 },
    { level: 344, quantity: 390 },
    { level: 345, quantity: 390 },
    { level: 346, quantity: 390 },
    { level: 347, quantity: 390 },
    { level: 348, quantity: 390 },
    { level: 349, quantity: 390 },
    { level: 350, quantity: 390 },
    { level: 351, quantity: 390 },
    { level: 352, quantity: 390 },
    { level: 353, quantity: 390 },
    { level: 354, quantity: 390 },
    { level: 355, quantity: 390 },
    { level: 356, quantity: 390 },
    { level: 357, quantity: 390 },
    { level: 358, quantity: 390 },
    { level: 359, quantity: 390 },
    { level: 360, quantity: 390 },
    { level: 361, quantity: 400 },
    { level: 362, quantity: 400 },
    { level: 363, quantity: 400 },
    { level: 364, quantity: 400 },
    { level: 365, quantity: 400 },
    { level: 366, quantity: 400 },
    { level: 367, quantity: 400 },
    { level: 368, quantity: 400 },
    { level: 369, quantity: 400 },
    { level: 370, quantity: 400 },
    { level: 371, quantity: 400 },
    { level: 372, quantity: 400 },
    { level: 373, quantity: 400 },
    { level: 374, quantity: 400 },
    { level: 375, quantity: 400 },
    { level: 376, quantity: 400 },
    { level: 377, quantity: 400 },
    { level: 378, quantity: 400 },
    { level: 379, quantity: 410 },
    { level: 380, quantity: 410 },
    { level: 381, quantity: 410 },
    { level: 382, quantity: 410 },
    { level: 383, quantity: 410 },
    { level: 384, quantity: 410 },
    { level: 385, quantity: 410 },
    { level: 386, quantity: 410 },
    { level: 387, quantity: 410 },
    { level: 388, quantity: 410 },
    { level: 389, quantity: 410 },
    { level: 390, quantity: 410 },
    { level: 391, quantity: 410 },
    { level: 392, quantity: 410 },
    { level: 393, quantity: 410 },
    { level: 394, quantity: 410 },
    { level: 395, quantity: 410 },
    { level: 396, quantity: 410 },
    { level: 397, quantity: 420 },
    { level: 398, quantity: 420 },
    { level: 399, quantity: 420 },
    { level: 400, quantity: 420 },
    { level: 401, quantity: 420 },
    { level: 402, quantity: 420 },
    { level: 403, quantity: 420 },
    { level: 404, quantity: 420 },
    { level: 405, quantity: 420 },
    { level: 406, quantity: 420 },
    { level: 407, quantity: 420 },
    { level: 408, quantity: 420 },
    { level: 409, quantity: 420 },
    { level: 410, quantity: 420 },
    { level: 411, quantity: 420 },
    { level: 412, quantity: 420 },
    { level: 413, quantity: 420 },
    { level: 414, quantity: 420 },
    { level: 415, quantity: 430 },
    { level: 416, quantity: 430 },
    { level: 417, quantity: 430 },
    { level: 418, quantity: 430 },
    { level: 419, quantity: 430 },
    { level: 420, quantity: 430 },
    { level: 421, quantity: 430 },
    { level: 422, quantity: 430 },
    { level: 423, quantity: 430 },
    { level: 424, quantity: 430 },
    { level: 425, quantity: 430 },
    { level: 426, quantity: 430 },
    { level: 427, quantity: 430 },
    { level: 428, quantity: 430 },
    { level: 429, quantity: 430 },
    { level: 430, quantity: 430 },
    { level: 431, quantity: 430 },
    { level: 432, quantity: 430 },
    { level: 433, quantity: 440 },
    { level: 434, quantity: 440 },
    { level: 435, quantity: 440 },
    { level: 436, quantity: 440 },
    { level: 437, quantity: 440 },
    { level: 438, quantity: 440 },
    { level: 439, quantity: 440 },
    { level: 440, quantity: 440 },
    { level: 441, quantity: 440 },
    { level: 442, quantity: 440 },
    { level: 443, quantity: 440 },
    { level: 444, quantity: 440 },
    { level: 445, quantity: 440 },
    { level: 446, quantity: 440 },
    { level: 447, quantity: 440 },
    { level: 448, quantity: 440 },
    { level: 449, quantity: 440 },
    { level: 450, quantity: 440 }
  ],
  gold: [
    { level: 1, quantity: 65 },
    { level: 2, quantity: 65 },
    { level: 3, quantity: 65 },
    { level: 4, quantity: 65 },
    { level: 5, quantity: 65 },
    { level: 6, quantity: 65 },
    { level: 7, quantity: 65 },
    { level: 8, quantity: 65 },
    { level: 9, quantity: 65 },
    { level: 10, quantity: 65 },
    { level: 11, quantity: 65 },
    { level: 12, quantity: 65 },
    { level: 13, quantity: 65 },
    { level: 14, quantity: 65 },
    { level: 15, quantity: 65 },
    { level: 16, quantity: 65 },
    { level: 17, quantity: 65 },
    { level: 18, quantity: 65 },
    { level: 19, quantity: 105 },
    { level: 20, quantity: 105 },
    { level: 21, quantity: 105 },
    { level: 22, quantity: 105 },
    { level: 23, quantity: 105 },
    { level: 24, quantity: 105 },
    { level: 25, quantity: 105 },
    { level: 26, quantity: 105 },
    { level: 27, quantity: 105 },
    { level: 28, quantity: 105 },
    { level: 29, quantity: 105 },
    { level: 30, quantity: 105 },
    { level: 31, quantity: 105 },
    { level: 32, quantity: 105 },
    { level: 33, quantity: 105 },
    { level: 34, quantity: 105 },
    { level: 35, quantity: 105 },
    { level: 36, quantity: 105 },
    { level: 37, quantity: 145 },
    { level: 38, quantity: 145 },
    { level: 39, quantity: 145 },
    { level: 40, quantity: 145 },
    { level: 41, quantity: 145 },
    { level: 42, quantity: 145 },
    { level: 43, quantity: 145 },
    { level: 44, quantity: 145 },
    { level: 45, quantity: 145 },
    { level: 46, quantity: 145 },
    { level: 47, quantity: 145 },
    { level: 48, quantity: 145 },
    { level: 49, quantity: 145 },
    { level: 50, quantity: 145 },
    { level: 51, quantity: 145 },
    { level: 52, quantity: 145 },
    { level: 53, quantity: 145 },
    { level: 54, quantity: 145 },
    { level: 55, quantity: 180 },
    { level: 56, quantity: 180 },
    { level: 57, quantity: 180 },
    { level: 58, quantity: 180 },
    { level: 59, quantity: 180 },
    { level: 60, quantity: 180 },
    { level: 61, quantity: 180 },
    { level: 62, quantity: 180 },
    { level: 63, quantity: 180 },
    { level: 64, quantity: 180 },
    { level: 65, quantity: 180 },
    { level: 66, quantity: 180 },
    { level: 67, quantity: 180 },
    { level: 68, quantity: 180 },
    { level: 69, quantity: 180 },
    { level: 70, quantity: 180 },
    { level: 71, quantity: 180 },
    { level: 72, quantity: 180 },
    { level: 73, quantity: 205 },
    { level: 74, quantity: 205 },
    { level: 75, quantity: 205 },
    { level: 76, quantity: 205 },
    { level: 77, quantity: 205 },
    { level: 78, quantity: 205 },
    { level: 79, quantity: 205 },
    { level: 80, quantity: 205 },
    { level: 81, quantity: 205 },
    { level: 82, quantity: 205 },
    { level: 83, quantity: 205 },
    { level: 84, quantity: 205 },
    { level: 85, quantity: 205 },
    { level: 86, quantity: 205 },
    { level: 87, quantity: 205 },
    { level: 88, quantity: 205 },
    { level: 89, quantity: 205 },
    { level: 90, quantity: 205 },
    { level: 91, quantity: 235 },
    { level: 92, quantity: 235 },
    { level: 93, quantity: 235 },
    { level: 94, quantity: 235 },
    { level: 95, quantity: 235 },
    { level: 96, quantity: 235 },
    { level: 97, quantity: 235 },
    { level: 98, quantity: 235 },
    { level: 99, quantity: 235 },
    { level: 100, quantity: 235 },
    { level: 101, quantity: 235 },
    { level: 102, quantity: 235 },
    { level: 103, quantity: 235 },
    { level: 104, quantity: 235 },
    { level: 105, quantity: 235 },
    { level: 106, quantity: 235 },
    { level: 107, quantity: 235 },
    { level: 108, quantity: 235 },
    { level: 109, quantity: 270 },
    { level: 110, quantity: 270 },
    { level: 111, quantity: 270 },
    { level: 112, quantity: 270 },
    { level: 113, quantity: 270 },
    { level: 114, quantity: 270 },
    { level: 115, quantity: 270 },
    { level: 116, quantity: 270 },
    { level: 117, quantity: 270 },
    { level: 118, quantity: 270 },
    { level: 119, quantity: 270 },
    { level: 120, quantity: 270 },
    { level: 121, quantity: 270 },
    { level: 122, quantity: 270 },
    { level: 123, quantity: 270 },
    { level: 124, quantity: 270 },
    { level: 125, quantity: 270 },
    { level: 126, quantity: 270 },
    { level: 127, quantity: 310 },
    { level: 128, quantity: 310 },
    { level: 129, quantity: 310 },
    { level: 130, quantity: 310 },
    { level: 131, quantity: 310 },
    { level: 132, quantity: 310 },
    { level: 133, quantity: 310 },
    { level: 134, quantity: 310 },
    { level: 135, quantity: 310 },
    { level: 136, quantity: 310 },
    { level: 137, quantity: 310 },
    { level: 138, quantity: 310 },
    { level: 139, quantity: 310 },
    { level: 140, quantity: 310 },
    { level: 141, quantity: 310 },
    { level: 142, quantity: 310 },
    { level: 143, quantity: 310 },
    { level: 144, quantity: 310 },
    { level: 145, quantity: 350 },
    { level: 146, quantity: 350 },
    { level: 147, quantity: 350 },
    { level: 148, quantity: 350 },
    { level: 149, quantity: 350 },
    { level: 150, quantity: 350 },
    { level: 151, quantity: 350 },
    { level: 152, quantity: 350 },
    { level: 153, quantity: 350 },
    { level: 154, quantity: 350 },
    { level: 155, quantity: 350 },
    { level: 156, quantity: 350 },
    { level: 157, quantity: 350 },
    { level: 158, quantity: 350 },
    { level: 159, quantity: 350 },
    { level: 160, quantity: 350 },
    { level: 161, quantity: 350 },
    { level: 162, quantity: 350 },
    { level: 163, quantity: 390 },
    { level: 164, quantity: 390 },
    { level: 165, quantity: 390 },
    { level: 166, quantity: 390 },
    { level: 167, quantity: 390 },
    { level: 168, quantity: 390 },
    { level: 169, quantity: 390 },
    { level: 170, quantity: 390 },
    { level: 171, quantity: 390 },
    { level: 172, quantity: 390 },
    { level: 173, quantity: 390 },
    { level: 174, quantity: 390 },
    { level: 175, quantity: 390 },
    { level: 176, quantity: 390 },
    { level: 177, quantity: 390 },
    { level: 178, quantity: 390 },
    { level: 179, quantity: 390 },
    { level: 180, quantity: 390 },
    { level: 181, quantity: 440 },
    { level: 182, quantity: 440 },
    { level: 183, quantity: 440 },
    { level: 184, quantity: 440 },
    { level: 185, quantity: 440 },
    { level: 186, quantity: 440 },
    { level: 187, quantity: 440 },
    { level: 188, quantity: 440 },
    { level: 189, quantity: 440 },
    { level: 190, quantity: 440 },
    { level: 191, quantity: 440 },
    { level: 192, quantity: 440 },
    { level: 193, quantity: 440 },
    { level: 194, quantity: 440 },
    { level: 195, quantity: 440 },
    { level: 196, quantity: 440 },
    { level: 197, quantity: 440 },
    { level: 198, quantity: 440 },
    { level: 199, quantity: 490 },
    { level: 200, quantity: 490 },
    { level: 201, quantity: 490 },
    { level: 202, quantity: 490 },
    { level: 203, quantity: 490 },
    { level: 204, quantity: 490 },
    { level: 205, quantity: 490 },
    { level: 206, quantity: 490 },
    { level: 207, quantity: 490 },
    { level: 208, quantity: 490 },
    { level: 209, quantity: 490 },
    { level: 210, quantity: 490 },
    { level: 211, quantity: 490 },
    { level: 212, quantity: 490 },
    { level: 213, quantity: 490 },
    { level: 214, quantity: 490 },
    { level: 215, quantity: 490 },
    { level: 216, quantity: 490 },
    { level: 217, quantity: 550 },
    { level: 218, quantity: 550 },
    { level: 219, quantity: 550 },
    { level: 220, quantity: 550 },
    { level: 221, quantity: 550 },
    { level: 222, quantity: 550 },
    { level: 223, quantity: 550 },
    { level: 224, quantity: 550 },
    { level: 225, quantity: 550 },
    { level: 226, quantity: 550 },
    { level: 227, quantity: 550 },
    { level: 228, quantity: 550 },
    { level: 229, quantity: 550 },
    { level: 230, quantity: 550 },
    { level: 231, quantity: 550 },
    { level: 232, quantity: 550 },
    { level: 233, quantity: 550 },
    { level: 234, quantity: 550 },
    { level: 235, quantity: 635 },
    { level: 236, quantity: 635 },
    { level: 237, quantity: 635 },
    { level: 238, quantity: 635 },
    { level: 239, quantity: 635 },
    { level: 240, quantity: 635 },
    { level: 241, quantity: 635 },
    { level: 242, quantity: 635 },
    { level: 243, quantity: 635 },
    { level: 244, quantity: 635 },
    { level: 245, quantity: 635 },
    { level: 246, quantity: 635 },
    { level: 247, quantity: 635 },
    { level: 248, quantity: 635 },
    { level: 249, quantity: 635 },
    { level: 250, quantity: 635 },
    { level: 251, quantity: 635 },
    { level: 252, quantity: 635 },
    { level: 253, quantity: 710 },
    { level: 254, quantity: 710 },
    { level: 255, quantity: 710 },
    { level: 256, quantity: 710 },
    { level: 257, quantity: 710 },
    { level: 258, quantity: 710 },
    { level: 259, quantity: 710 },
    { level: 260, quantity: 710 },
    { level: 261, quantity: 710 },
    { level: 262, quantity: 710 },
    { level: 263, quantity: 710 },
    { level: 264, quantity: 710 },
    { level: 265, quantity: 710 },
    { level: 266, quantity: 710 },
    { level: 267, quantity: 710 },
    { level: 268, quantity: 710 },
    { level: 269, quantity: 710 },
    { level: 270, quantity: 710 },
    { level: 271, quantity: 800 },
    { level: 272, quantity: 800 },
    { level: 273, quantity: 800 },
    { level: 274, quantity: 800 },
    { level: 275, quantity: 800 },
    { level: 276, quantity: 800 },
    { level: 277, quantity: 800 },
    { level: 278, quantity: 800 },
    { level: 279, quantity: 800 },
    { level: 280, quantity: 800 },
    { level: 281, quantity: 800 },
    { level: 282, quantity: 800 },
    { level: 283, quantity: 800 },
    { level: 284, quantity: 800 },
    { level: 285, quantity: 800 },
    { level: 286, quantity: 800 },
    { level: 287, quantity: 800 },
    { level: 288, quantity: 800 },
    { level: 289, quantity: 900 },
    { level: 290, quantity: 900 },
    { level: 291, quantity: 900 },
    { level: 292, quantity: 900 },
    { level: 293, quantity: 900 },
    { level: 294, quantity: 900 },
    { level: 295, quantity: 900 },
    { level: 296, quantity: 900 },
    { level: 297, quantity: 900 },
    { level: 298, quantity: 900 },
    { level: 299, quantity: 900 },
    { level: 300, quantity: 900 },
    { level: 301, quantity: 900 },
    { level: 302, quantity: 900 },
    { level: 303, quantity: 900 },
    { level: 304, quantity: 900 },
    { level: 305, quantity: 900 },
    { level: 306, quantity: 900 },
    { level: 307, quantity: 1000 },
    { level: 308, quantity: 1000 },
    { level: 309, quantity: 1000 },
    { level: 310, quantity: 1000 },
    { level: 311, quantity: 1000 },
    { level: 312, quantity: 1000 },
    { level: 313, quantity: 1000 },
    { level: 314, quantity: 1000 },
    { level: 315, quantity: 1000 },
    { level: 316, quantity: 1000 },
    { level: 317, quantity: 1000 },
    { level: 318, quantity: 1000 },
    { level: 319, quantity: 1000 },
    { level: 320, quantity: 1000 },
    { level: 321, quantity: 1000 },
    { level: 322, quantity: 1000 },
    { level: 323, quantity: 1000 },
    { level: 324, quantity: 1000 },
    { level: 325, quantity: 1100 },
    { level: 326, quantity: 1100 },
    { level: 327, quantity: 1100 },
    { level: 328, quantity: 1100 },
    { level: 329, quantity: 1100 },
    { level: 330, quantity: 1100 },
    { level: 331, quantity: 1100 },
    { level: 332, quantity: 1100 },
    { level: 333, quantity: 1100 },
    { level: 334, quantity: 1100 },
    { level: 335, quantity: 1100 },
    { level: 336, quantity: 1100 },
    { level: 337, quantity: 1100 },
    { level: 338, quantity: 1100 },
    { level: 339, quantity: 1100 },
    { level: 340, quantity: 1100 },
    { level: 341, quantity: 1100 },
    { level: 342, quantity: 1100 },
    { level: 343, quantity: 1200 },
    { level: 344, quantity: 1200 },
    { level: 345, quantity: 1200 },
    { level: 346, quantity: 1200 },
    { level: 347, quantity: 1200 },
    { level: 348, quantity: 1200 },
    { level: 349, quantity: 1200 },
    { level: 350, quantity: 1200 },
    { level: 351, quantity: 1200 },
    { level: 352, quantity: 1200 },
    { level: 353, quantity: 1200 },
    { level: 354, quantity: 1200 },
    { level: 355, quantity: 1200 },
    { level: 356, quantity: 1200 },
    { level: 357, quantity: 1200 },
    { level: 358, quantity: 1200 },
    { level: 359, quantity: 1200 },
    { level: 360, quantity: 1200 },
    { level: 361, quantity: 1250 },
    { level: 362, quantity: 1250 },
    { level: 363, quantity: 1250 },
    { level: 364, quantity: 1250 },
    { level: 365, quantity: 1250 },
    { level: 366, quantity: 1250 },
    { level: 367, quantity: 1250 },
    { level: 368, quantity: 1250 },
    { level: 369, quantity: 1250 },
    { level: 370, quantity: 1250 },
    { level: 371, quantity: 1250 },
    { level: 372, quantity: 1250 },
    { level: 373, quantity: 1250 },
    { level: 374, quantity: 1250 },
    { level: 375, quantity: 1250 },
    { level: 376, quantity: 1250 },
    { level: 377, quantity: 1250 },
    { level: 378, quantity: 1250 },
    { level: 379, quantity: 1300 },
    { level: 380, quantity: 1300 },
    { level: 381, quantity: 1300 },
    { level: 382, quantity: 1300 },
    { level: 383, quantity: 1300 },
    { level: 384, quantity: 1300 },
    { level: 385, quantity: 1300 },
    { level: 386, quantity: 1300 },
    { level: 387, quantity: 1300 },
    { level: 388, quantity: 1300 },
    { level: 389, quantity: 1300 },
    { level: 390, quantity: 1300 },
    { level: 391, quantity: 1300 },
    { level: 392, quantity: 1300 },
    { level: 393, quantity: 1300 },
    { level: 394, quantity: 1300 },
    { level: 395, quantity: 1300 },
    { level: 396, quantity: 1300 },
    { level: 397, quantity: 1350 },
    { level: 398, quantity: 1350 },
    { level: 399, quantity: 1350 },
    { level: 400, quantity: 1350 },
    { level: 401, quantity: 1350 },
    { level: 402, quantity: 1350 },
    { level: 403, quantity: 1350 },
    { level: 404, quantity: 1350 },
    { level: 405, quantity: 1350 },
    { level: 406, quantity: 1350 },
    { level: 407, quantity: 1350 },
    { level: 408, quantity: 1350 },
    { level: 409, quantity: 1350 },
    { level: 410, quantity: 1350 },
    { level: 411, quantity: 1350 },
    { level: 412, quantity: 1350 },
    { level: 413, quantity: 1350 },
    { level: 414, quantity: 1350 },
    { level: 415, quantity: 1400 },
    { level: 416, quantity: 1400 },
    { level: 417, quantity: 1400 },
    { level: 418, quantity: 1400 },
    { level: 419, quantity: 1400 },
    { level: 420, quantity: 1400 },
    { level: 421, quantity: 1400 },
    { level: 422, quantity: 1400 },
    { level: 423, quantity: 1400 },
    { level: 424, quantity: 1400 },
    { level: 425, quantity: 1400 },
    { level: 426, quantity: 1400 },
    { level: 427, quantity: 1400 },
    { level: 428, quantity: 1400 },
    { level: 429, quantity: 1400 },
    { level: 430, quantity: 1400 },
    { level: 431, quantity: 1400 },
    { level: 432, quantity: 1400 },
    { level: 433, quantity: 1450 },
    { level: 434, quantity: 1450 },
    { level: 435, quantity: 1450 },
    { level: 436, quantity: 1450 },
    { level: 437, quantity: 1450 },
    { level: 438, quantity: 1450 },
    { level: 439, quantity: 1450 },
    { level: 440, quantity: 1450 },
    { level: 441, quantity: 1450 },
    { level: 442, quantity: 1450 },
    { level: 443, quantity: 1450 },
    { level: 444, quantity: 1450 },
    { level: 445, quantity: 1450 },
    { level: 446, quantity: 1450 },
    { level: 447, quantity: 1450 },
    { level: 448, quantity: 1450 },
    { level: 449, quantity: 1450 },
    { level: 450, quantity: 1450 }
  ]
}

export const totemInfo = {
  stone: {
    blue: { avgPrice: { qty: 350, p: 4.99 } },
    purple: { avgPrice: { qty: 180, p: 4.99 } },
    gold: { avgPrice: { qty: 180, p: 4.99 } }
  },
  scroll: {
    blue: { avgPrice: { qty: 25, p: 4.99 } },
    purple: { avgPrice: { qty: 25, p: 4.99 } },
    gold: { avgPrice: { qty: 6, p: 9.99 } }
  }
}

export const totemTemplates = [
  {
    key: 'blueToPurpleR',
    desc: 'Blue to Purple (Recomended)',
    config: { blueLevel: 120, purpleLevel: 144, goldLevel: 0 }
  },
  {
    key: 'purpleToGoldR',
    desc: 'Purple to Gold (Recommended)',
    config: { blueLevel: 0, purpleLevel: 450, goldLevel: 270 }
  },
  {
    key: 'purpleToGoldA',
    desc: 'Purple to Gold (All Purple Stats)',
    config: { blueLevel: 0, purpleLevel: 450, goldLevel: 350 }
  },

  {
    key: 'blueToPurpleA',
    desc: 'Blue to Purple (All Blue Stats)',
    config: { blueLevel: 120, purpleLevel: 308, goldLevel: 0 }
  },
  {
    key: 'purpleToGold200',
    desc: 'Purple lv200 to Gold (Stones Equivalent)',
    config: { blueLevel: 0, purpleLevel: 200, goldLevel: 98 }
  },
  {
    key: 'purpleToGold250',
    desc: 'Purple lv250 to Gold (Stones Equivalent)',
    config: { blueLevel: 0, purpleLevel: 250, goldLevel: 128 }
  },
  {
    key: 'purpleToGold300',
    desc: 'Purple lv300 to Gold (Stones Equivalent)',
    config: { blueLevel: 0, purpleLevel: 300, goldLevel: 163 }
  },
  {
    key: 'purpleToGold350',
    desc: 'Purple lv350 to Gold (Stones Equivalent)',
    config: { blueLevel: 0, purpleLevel: 350, goldLevel: 203 }
  },
  {
    key: 'purpleToGold400',
    desc: 'Purple lv400 to Gold (Stones Equivalent)',
    config: { blueLevel: 0, purpleLevel: 400, goldLevel: 240 }
  },
  {
    key: 'purpleToGold450',
    desc: 'Purple lv450 to Gold (Stones Equivalent)',
    config: { blueLevel: 0, purpleLevel: 450, goldLevel: 271 }
  }
]

export const totemConf = {
  levelType: [
    { value: 1, desc: 'Auto' },
    { value: 2, desc: 'Custom' }
  ]
}

export const totemSlots = [
  {
    slot: 1,
    quality: 'blue',
    level: 0,
    totem: '',
    mode: 1,
    totemObj: {},
    generalStats: [],
    stones: 0,
    scrolls: 0,
    nodes: { 1: 0, 2: 0, 3: 0 }
  },
  {
    slot: 2,
    quality: 'purple',
    level: 0,
    totem: '',
    mode: 1,
    totemObj: {},
    generalStats: [],
    stones: 0,
    scrolls: 0,
    nodes: { 1: 0, 2: 0, 3: 0 }
  },
  {
    slot: 3,
    quality: 'gold',
    level: 0,
    totem: '',
    mode: 1,
    totemObj: {},
    generalStats: [],
    stones: 0,
    scrolls: 0,
    nodes: { 1: 0, 2: 0, 3: 0 }
  }
]

export const totemRewards = [
  { event: 'daily', group: 'nrs', type: 'Normal Runestones', qty: 25, times: 10 },
  { event: 'weekly', group: 'nrs', type: 'Normal Runestones', qty: 75, times: 1 },
  { event: 'daily', group: 'bpt', type: 'Blue Psionic Tattoo', qty: 1, times: 10 },
  { event: 'daily', group: 'srs', type: 'Superior Runestones', qty: 1, times: 10 },
  { event: 'weekly', group: 'srs', type: 'Superior Runestones', qty: 9, times: 1, desc: '50/50 Quests Weekly Rewards' },
  {
    event: 'weekly',
    group: 'ppt',
    type: 'Purple Psionic Tattoo',
    qty: 4,
    times: 1,
    desc: '50/50 Quests Weekly Rewards'
  },
  { event: 'weekly', group: 'srs', type: 'Superior Runestones', qty: 10, times: 2, desc: 'Oracle Shop' },
  { event: 'weekly', group: 'ppt', type: 'Purple Psionic Tattoo', qty: 3, times: 1, desc: 'Oracle Shop' }
]
